import { FC } from 'react';
import { SingleValueProps, GroupBase, components } from 'react-select';
import { getIconByNetwork } from '@/helpers';
import { SelectOption } from '../models';

import styles from './FilterValueChain.module.sass';

const { SingleValue } = components;

export type FilterValueChainProps = SingleValueProps<
  SelectOption,
  false,
  GroupBase<SelectOption>
>;

const FilterValueChain: FC<FilterValueChainProps> = (props) => {
  const { children, ...restProps } = props;
  const { data } = restProps;
  const { label, value } = data;

  const iconSrc = getIconByNetwork(value);

  return (
    <SingleValue {...restProps}>
      <div className={styles.option}>
        <div className={styles.icon}>
          <img src={iconSrc} alt={label} />
        </div>
        <div className={styles.info}>
          <div className={styles.label}>{label}</div>
        </div>
      </div>
    </SingleValue>
  );
};

export default FilterValueChain;
